import type { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: 'all-suppliers',
    name: 'quick-connect',
    component: () => import('./QuickConnect.vue'),
  },
] satisfies RouteRecordRaw[];
